import ProjectCard from '../project/ProjectCard';

import { projectsData } from '../../img/utils/data';
import './projectList.css';

const ProjectList = () => {
	return (
		<div className='project-list'>
			<div className='project-list-texts'>
				<h2 className='project-list-title'> Collaborate & Create </h2>
				<p className='project-list-description'>
					My strong interpersonal skills have enabled me to work with both local
					and international teams in implementing projects and training seminars
					from ideation to completion.
				</p>
			</div>
			<div className='project-list-list'>
				{projectsData.map((item) => (
					<ProjectCard
						key={item.id}
						image={item.image}
					/>
				))}
			</div>
		</div>
	);
};

export default ProjectList;
